import script from "./AdvanceFilterTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvanceFilterTasks.vue?vue&type=script&setup=true&lang=js"

import "./AdvanceFilterTasks.vue?vue&type=style&index=0&id=407c835a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407c835a"]])

export default __exports__